<div class="card mt-3" [formGroup]="form">
    <div class="card-body">
        <div class="row">
            <div class="col-md-8">
                <h5 class="card-title main-blue">{{ 'CampDetails.Visiblity' | translate }}</h5>
            </div>
            <div class="col-md-4">
                <button class="btn btn-success btn-action pull-right" type="button" [disabled]="!isFormValid()" bcClick hznTestId="camp-visibility-save" (clicked)="save()">{{ 'General.Save' | translate }}</button>
                <button class="btn btn-danger btn-action pull-right mr-1" type="button" (click)="cancel()">{{ 'General.Cancel' | translate }}</button>
            </div>
        </div>
        <div class="card-text">
            <div class="row mt-1">
                <div class="col-sm-2 bolded">{{ 'CampDetails.VisibleInConnect' | translate }}</div>
                <div class="col-sm-10">
                    <ui-switch hznTestId="camp-visibility-visible-input" [checked]="form.controls.isVisibleToMembers.value" (change)="onVisibleChange($event)" class="switch" size="small" color="#346ABC" switchColor="white"></ui-switch>
                </div>
            </div>
        </div>
        <div class="card-text">
            <div class="row mt-1">
                <div class="col-sm-2 bolded">{{ 'CampDetails.DisplayedName' | translate }}</div>
                <div class="col-sm-10"><input class="form-control" hznTestId="camp-visibility-display-name-input" formControlName="displayName" maxlength="160" /></div>
            </div>
        </div>
        <div class="card-text">
            <div class="row mt-1">
                <div class="col-sm-2 bolded">{{ 'CampDetails.ShortDescription' | translate }}</div>
                <div class="col-sm-10"><textarea [required]="isVisible" rows="2" class="form-control" hznTestId="camp-visibility-short-description-input" formControlName="shortDescription" maxlength="700"></textarea></div>
            </div>
        </div>
        <div class="card-text">
            <div class="row mt-1">
                <div class="col-sm-2 bolded">{{ 'CampDetails.LongDescription' | translate }}</div>
                <div class="col-sm-10"><textarea [required]="isVisible" rows="5" class="form-control" hznTestId="camp-visibility-description-input" formControlName="description" maxlength="4000"></textarea></div>
            </div>
        </div>

        <div class="card-text">
            <div class="row mt-1">
                <div class="col-sm-2 bolded">{{ 'CampDetails.MemberWeeklyPrice' | translate }}</div>
                <div class="col-sm-10">
                    <app-amount-picker hznTestId="camp-visibility-member-weekly-price-input" formControlName="memberWeeklyPrice"></app-amount-picker>
                </div>
            </div>
        </div>

        <div class="card-text">
            <div class="row mt-1">
                <div class="col-sm-2 bolded">{{ 'CampDetails.GuestWeeklyPrice' | translate }}</div>
                <div class="col-sm-10">
                    <app-amount-picker hznTestId="camp-visibility-guest-weekly-price-input" formControlName="guestWeeklyPrice"></app-amount-picker>
                </div>
            </div>
        </div>
    </div>
</div>
